export function tail<T>(arr: T[]): T[] {
  return arr.slice(1)
}
